import { DataSource } from '@angular/cdk/table'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material'
import { Observable, of as observableOf, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { Notifications } from 'src/app/shared/models/Com/Notification';
import { NotificationService } from '../services/notification.service';

export class NotificationDataSource extends DataSource<Notifications> {


    constructor(private paginator: MatPaginator, private sort: MatSort,private NotificationsService:NotificationService) {
        super();
            // this.userService.getUsers().then((result) => this.data = (result as any).data) ;
            // console.log(this.data);
        this.NotificationsService.getNotifications().then((result) =>this.inilization(result));
        // console.log(this.Departments);
        // .then((result) => this.data = (result as any).data) ;

      }
    static staticData:Array<Notifications>;

    data:Array<Notifications>;
    notification:Array<Notifications>;

      connect(): Observable<Notifications[]> {
        // Combine everything that affects the rendered data into one update
        // stream for the data-table to consume.
        const dataMutations = [
          observableOf(this.data),
          this.paginator.page,
          this.sort.sortChange
        ];

        // Set the paginator's length
        this.paginator.length = this.data.length;

        return merge(...dataMutations).pipe(map(() => {
          return this.getPagedData(this.getSortedData([...this.data]));
        }));
      }


    disconnect(collectionViewer: import('@angular/cdk/collections').CollectionViewer): void {
        // throw new Error("Method not implemented.");
    }

    async inilization(result)
    {
      this.NotificationsService.Notifications = (result as any).data;
      // console.log(this.departmentService.deps);
      this.notification = this.NotificationsService.Notifications;
      if(NotificationDataSource.staticData == null)
        NotificationDataSource.staticData= await this.notification;
      this.data=NotificationDataSource.staticData;
      // console.log(this.Departments);
    }

    filter(filterValue: string , keys)
    {
      const newData=[];
      for(const object of  this.notification)
      {
        /* for(let propert in object)

          {console.log(Object.prototype.hasOwnProperty.call(object, propert));} */
          // console.log(Object.values(object));
          const objectValues = [];

          for(const key of Object.keys(object))
          {
            // console.log(1);

            if(keys.includes(key))
            {
             // console.log(1);
              objectValues.push(object[key]);
            }

          }
          // console.log(1);
          // console.log(objectValues);
          for(const value of objectValues )
          {
            if(typeof(value)=='string' && value.trim().toLowerCase().includes(filterValue))
            {
                newData.push(object);
                break;
            }
            else if( (typeof(value) == 'number' || value instanceof(Date) ) && value.toString().trim().toLowerCase().includes(filterValue))
            {
              newData.push(object);
              break;
           }
          }
      }
      // console.log(newData);
      NotificationDataSource.staticData = newData;

    }

   private getPagedData(data: Notifications[]) {
     const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
     return data.splice(startIndex, this.paginator.pageSize);
   }

   /**
    * Sort the data (client-side). If you're using server-side sorting,
    * this would be replaced by requesting the appropriate data from the server.
    */
   private getSortedData(data: Notifications[]) {
     if (!this.sort.active || this.sort.direction === '') {
       return data;
     }

     return data.sort((a, b) => {
       const isDec = this.sort.direction === 'desc';
       switch (this.sort.active) {
         case 'id': return compare(a.id, b.id, isDec);

//
         default: return 0;
       }
     });
   }

   Destroy()
  {
    NotificationDataSource.staticData = null;
  }

 }

 /** Simple sort comparator for example ID/Name columns (for client-side sorting). */
 function compare(a, b, isDec) {
  return (a > b ? -1 : 1) * (isDec ? 1 : -1);
 }

